/*
  component-common-footer.js

  Light-dismiss for the overlay-mode footer drawer (every non-home template).
  The drawer is a native <details>/<summary> in footer.liquid: the tab toggles
  it and CSS animates the slide plus the body::after blur scrim. Because the
  scrim is a pseudo-element it has no DOM node to bind, so closing on a backdrop
  click cannot be expressed in CSS. This adds the two dismiss affordances a
  scrimmed overlay is expected to have: a click outside the panel, and Escape.

  Inline mode (home) has no scrim and no tab, so we bail when there is no
  overlay drawer on the page. The native toggle still works with JS disabled;
  this is pure enhancement.
*/

(function () {
  'use strict';

  function init() {
    const details = document.querySelector(
      '.c-footer-drawer[data-mode="overlay"] > .c-footer-drawer__details'
    );
    if (!details) return;

    document.addEventListener('click', function (event) {
      /* The scrim is body::after, so a click on it lands on <body>, outside
         the details subtree. Clicks on the tab or panel stay inside it and are
         left to the native <details> toggle. */
      if (shouldDismiss(details, event.target)) details.open = false;
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && details.open) details.open = false;
    });
  }

  /* Dismiss only an open drawer, and only when the click landed outside the
     details subtree. The scrim is body::after, so its clicks resolve to <body>
     (outside) and close; clicks on the tab or panel stay inside and fall
     through to the native <details> toggle. */
  function shouldDismiss(details, target) {
    return details.open && !target.closest('.c-footer-drawer__details');
  }

  document.addEventListener('DOMContentLoaded', init);
})();
